import { bindable, computedFrom } from 'aurelia-framework';
import { IImportAM } from './import-api';
import { ISetActionableParams } from './import-entry-buttons';

export class ExecuteImportButton {
	@bindable importEntry: IImportAM;
	@bindable executeImport: () => Promise<void>;
	@bindable setActionable: (params: ISetActionableParams) => void;
	@bindable stagedCount: number;
	@bindable errorCount: number;

	confirmVisible = false;

	@computedFrom('stagedCount', 'errorCount', 'importEntry.holdReasons')
	get enabled() {
		// A held replace/overwrite would be refused by the server anyway
		if (this.importEntry?.holdReasons?.length > 0) {
			return false;
		}
		return this.stagedCount > 0 || this.errorCount === 0;
	}

	toggleConfirm() {
		this.confirmVisible = !this.confirmVisible;
		this.setActionable({ actionable: this.confirmVisible });
	}

	async execute() {
		this.toggleConfirm();
		await this.executeImport();
	}
}
